module.exports = __webpack_public_path__ + "media/components/directory/assets/logo-on-white-b04f57b1d105e4ce9e68725a19c15d0b.png";